var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v("L'application est présentement indisponible")]),_c('p',[_vm._v(" L'application est présentement indisponible, mais nous serons de retour le plus tôt possible ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }